import { useTranslation } from "react-i18next"
import { FormAutocomplete, HelpModal, RowInfo, Switch } from "../../common"
import { lotteryGroupsState } from '../Rewards.state'
import { useRecoilState } from 'recoil'

const LotterySection = ({ useQuery }) => {
    const { t } = useTranslation()
    const [groups] = useRecoilState(lotteryGroupsState)
    const [collection] = useQuery()
    const minMaxOptions = [
        ...Array.from(Array(99).keys()).map(i => ({
            id: i + 1,
            name: String(i + 1),
        })),
    ]

    return (
        <>
            <RowInfo help={(
                <HelpModal title={t(`Lottery`)}>
                    <p>{t(`If off, the reward is given to every player who meets the criterion. 
                    If on, the reward will be given out randomly until limits are reached.`)}</p>
                </HelpModal>
            )}>
                <Switch
                    label={t(`Allocated via Lottery`)}
                    labels={{ on: "On", off: "Off" }}
                    on={1}
                    off={0}
                    name={'lottery'}
                    useQuery={useQuery}
                />
            </RowInfo>
            <RowInfo help={(
                <HelpModal title={t(`Lottery Group`)}>
                    <p>{t(`Use lottery groups to make sets of rewards like a deck of cards, or a set of monopoly properties etc.`)}</p>
                </HelpModal>
            )}>
                <FormAutocomplete
                    label={t("Lottery Group")}
                    name="lottery_group"
                    useQuery={useQuery}
                    options={groups}
                    size="small"
                    parseInteger={false}
                    creatable
                />
            </RowInfo>
            <RowInfo help={(
                <HelpModal title={t(`Minimum Rewards`)}>
                    <p>{t(`If set to 1, the player is eligible for this reward only. 
                    If greater than 1, the player will be eligible for this number of rewards at minimum 
                    from the same lottery group. As example, this let's you award the player between 3 (minimum) 
                    and 5 (maximum) playing cards all at once as soon as this reward's criterion are satisfied.`)}</p>
                </HelpModal>
            )}>
                <FormAutocomplete
                    label={t("Minimum")}
                    name="lottery_min"
                    useQuery={useQuery}
                    options={minMaxOptions}
                    size="small"
                    maxValue={collection?.['lottery_max']}
                    creatable
                />
            </RowInfo>
            <RowInfo help={(
                <HelpModal title={t(`Maximum Rewards`)}>
                    <p>{t(`If set to 1, the player is eligible for this reward only. 
                    If greater than 1, the player will be eligible for this number of rewards maximum from 
                    the same lottery group.`)}</p>
                </HelpModal>
            )}>
                <FormAutocomplete
                    label={t("Maximum")}
                    name="lottery_max"
                    useQuery={useQuery}
                    options={minMaxOptions}
                    size="small"
                    minValue={collection?.['lottery_min']}
                    creatable
                />
            </RowInfo>
        </>
    )
}

export default LotterySection
